<template>

    <div>
        <label class="control-label col-xl-4">{{ contactType.name }}:</label>
        <div class="col-xl-8">
            <div class="input-group">
                <input type="text" class="form-control" disabled tabindex="1" v-if="getContacts" :value="getValue" />
                <span class="input-group-btn">
                    <button class="btn btn-info btn-sm" @click="openSearch(contactType)" v-tooltip="'Contact zoeken'"><i class="mdi mdi-account-search" /></button>
                    <button class="btn btn-danger btn-sm" @click="detachContact" :disabled="!exists" v-tooltip="'Ontkoppelen'"><i class="mdi mdi-delete-empty" /></button>
                </span>
            </div>
        </div>
    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        computed: {

            ...mapGetters([
                "getContacts",
            ]),

            exists() {
                return this.getContacts[this.contactType.id];
            },

            getValue() {
                if (!this.exists) { return ""; }
                let contact = this.getContacts[this.contactType.id];
                // Check if its a company
                if (!contact.is_contact) {
                    return contact.company_name;
                } else {
                    if (contact.company_name === null || contact.company_name === "") {
                        return contact.full_name;
                    } else {
                        return contact.full_name + " (" + contact.company_name + ")";
                    }
                }
            },

        },

        methods: {

            detachContact() {
                this.$emit('detach-contact', this.contactType);
            },

        },

        name:"ProjectsFormContact",

        props: {
            contactType: {
                required:true,
                type:Object,
            },
            openSearch: {
                required:true,
                type:Function
            },
        }
    }
</script>
